import L from "leaflet";
import "leaflet.markercluster";

// RedM live-map tile pyramid (zoom levels 1–6), served from /public/maptiles.
export const TILE_MAXZOOM = 6;          // highest native tile level available
export const VIEW_MAXZOOM = 9;          // allow digital over-zoom past native tiles for precise placement/viewing
export const TILE_W = 48 * 256; // full pixel width at max zoom
export const TILE_H = 38 * 256; // full pixel height at max zoom
export const TILE_URL = `${process.env.PUBLIC_URL || ""}/maptiles/{z}/{x}_{y}.jpg`;
export const TEAL = "rgb(var(--brand-teal))";
export const RED = "#8a1f1f";
const TRANSPARENT_PX = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

export const createTileMap = (el, opts = {}) => {
  const map = L.map(el, {
    crs: L.CRS.Simple,
    minZoom: 1,
    maxZoom: VIEW_MAXZOOM,
    attributionControl: false,
    maxBoundsViscosity: 1,
    ...opts,
  });
  const sw = map.unproject([0, TILE_H], TILE_MAXZOOM);
  const ne = map.unproject([TILE_W, 0], TILE_MAXZOOM);
  const bounds = new L.LatLngBounds(sw, ne);
  L.tileLayer(TILE_URL, {
    minZoom: 1,
    maxZoom: VIEW_MAXZOOM,
    maxNativeZoom: TILE_MAXZOOM,  // upscale native z6 tiles for z7-9 (soft but zoomable)
    tileSize: 256,
    noWrap: true,
    bounds,
    errorTileUrl: TRANSPARENT_PX,
  }).addTo(map);
  map.fitBounds(bounds);
  map.setMaxBounds(bounds);
  return { map, bounds };
};

export const pctToLatLng = (map, x, y) =>
  map.unproject([(Number(x) / 100) * TILE_W, (Number(y) / 100) * TILE_H], TILE_MAXZOOM);

export const latLngToPct = (map, latlng) => {
  const p = map.project(latlng, TILE_MAXZOOM);
  return {
    x: Math.min(100, Math.max(0, +((p.x / TILE_W) * 100).toFixed(2))),
    y: Math.min(100, Math.max(0, +((p.y / TILE_H) * 100).toFixed(2))),
  };
};

export const pinIcon = (forSale) =>
  L.divIcon({
    className: "",
    iconSize: [24, 30],
    iconAnchor: [12, 30],
    popupAnchor: [0, -28],
    html: `<svg width="24" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="fill:${forSale ? TEAL : RED};stroke:#0d0b09;stroke-width:1.2;filter:drop-shadow(0 1px 2px rgba(0,0,0,.8))"><path d="M12 0C7 0 3 4 3 9c0 6 9 15 9 15s9-9 9-15c0-5-4-9-9-9z"/><circle cx="12" cy="9" r="3" style="fill:#0d0b09;stroke:none"/></svg>`,
  });

export const clusterIcon = (cluster) => {
  const kids = cluster.getAllChildMarkers();
  const hasSale = kids.some((m) => m.options.forSale);
  const count = cluster.getChildCount();
  return L.divIcon({
    className: "",
    iconSize: [36, 36],
    html: `<div style="display:flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:9999px;border:2px solid ${hasSale ? TEAL : RED};background:rgba(13,11,9,0.92);color:${hasSale ? TEAL : "#e8e0d4"};font:700 12px ui-monospace,monospace;box-shadow:0 2px 6px rgba(0,0,0,.6)">${count}</div>`,
  });
};
